import { flattenValues } from "@uniformdev/canvas";
import { UniformCustomerQuote } from "src/uniform/contenttypes/customerQuote";
import { UniformCustomerStat } from "src/uniform/contenttypes/customerStat";

import { CustomerQuote } from "@/libraries/design/components/customer-quote/src/customer-quote";
import { CustomerStat } from "@/libraries/design/components/customer-stat/src/customer-stat";
import { GalleryContainer } from "@/libraries/design/components/gallery-container/src/gallery-container";

export interface UniformCustomerGalleryProps {
    items: (UniformCustomerQuote | UniformCustomerStat)[];
    isMotionAvailable?: boolean;
    motionDelay?: string;
    motionForward?: string;
    motionBackward?: string;
}

const UniformCustomerGallery = ({
    items,
    isMotionAvailable,
    motionDelay,
    motionForward: transformForward,
    motionBackward: transformBackward
}: UniformCustomerGalleryProps) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flattenedItems = flattenValues(items as any) as (
        | UniformCustomerQuote
        | UniformCustomerStat
    )[];
    return (
        <GalleryContainer
            isMotionAvailable={isMotionAvailable}
            motionDelay={motionDelay}
        >
            {/* eslint-disable-next-line complexity */}
            {flattenedItems.map((item, index) => {
                if (item) {
                    if ("quote" in item) {
                        return (
                            <div
                                key={index}
                                className="entry-item"
                                style={{
                                    // @ts-expect-error -- CSS custom property not in CSSProperties type
                                    "--gc-item-i": index
                                }}
                            >
                                <CustomerQuote
                                    logoSrc={item.companyLogo?.at(0)?.src ?? ""}
                                    logoAlt={item.companyLogo?.at(0)?.alt ?? ""}
                                    name={item.advocateName ?? ""}
                                    title={item.advocateJobTitle ?? ""}
                                    company={item.companyName ?? ""}
                                    quote={item.quote ?? ""}
                                    ctaLinkText={item.ctaLinkText}
                                    ctaLinkUrl={item.ctaUrl}
                                    ctaLinkDataEventProps={
                                        item.ctaLinkText
                                            ? {
                                                  "data-event": "clicked",
                                                  "data-event-component":
                                                      "linkButton",
                                                  "data-event-container":
                                                      "customersSection",
                                                  "data-product-key": "uniform",
                                                  "data-label": item.ctaLinkText
                                              }
                                            : undefined
                                    }
                                    imageSrc={
                                        item.advocateHeadshot?.at(0)?.src ?? ""
                                    }
                                    imageAlt={item.advocateHeadshot?.at(0)?.alt}
                                    color={item.color}
                                    motionConfig={
                                        transformForward && transformBackward
                                            ? {
                                                  transformForward,
                                                  transformBackward
                                              }
                                            : undefined
                                    }
                                />
                            </div>
                        );
                    } else if ("statNumber" in item) {
                        return (
                            <div
                                key={index}
                                className="entry-item"
                                style={{
                                    // @ts-expect-error -- CSS custom property not in CSSProperties type
                                    "--gc-item-i": index
                                }}
                            >
                                <CustomerStat
                                    logoSrc={item.logo?.at(0)?.src ?? ""}
                                    logoAlt={item.logo?.at(0)?.alt ?? ""}
                                    statValue={
                                        item.statNumber?.toString() ?? ""
                                    }
                                    statModifier={item.statModifier}
                                    description={item.description ?? ""}
                                    linkText={item.ctaText}
                                    linkHref={item.ctaUrl}
                                    linkDataEventProps={
                                        item.ctaText
                                            ? {
                                                  "data-event": "clicked",
                                                  "data-event-component":
                                                      "linkButton",
                                                  "data-event-container":
                                                      "customersSection",
                                                  "data-product-key": "uniform",
                                                  "data-label": item.ctaText
                                              }
                                            : undefined
                                    }
                                    color={item.color}
                                    motionConfig={
                                        transformForward && transformBackward
                                            ? {
                                                  transformForward,
                                                  transformBackward
                                              }
                                            : undefined
                                    }
                                />
                            </div>
                        );
                    }
                }
            })}
        </GalleryContainer>
    );
};

export default UniformCustomerGallery;
